/* The custom safety cover landing page: the price estimator, and the option pills.
 *
 * The model is not a curve fitted to two published figures. It is the configuration the sister site's
 * own calculator runs on, read off its page and recorded with its own comments in
 * docs/ops/2026-09-23-sc-guides/facts-estimator.md. Dylan, 2026-09-23: "trust poolzoom."
 *
 *   cover sqft = pool sqft plus an overlap that depends on shape and size
 *   rate       = a per sqft figure from a seven step bracket table, in one of three grid columns
 *   price      = rate * cover sqft + a flat shape adder, rounded to $5
 *
 * Validated against the one worked example the source publishes: a 640 sqft cover returns $1,150 at the
 * entry mesh and $1,665 at commercial, which is exactly the band on their page.
 *
 * Two things it must keep doing:
 *   - Refuse where the model refuses. Commercial mesh is not produced above 2,099 sqft and the solid
 *     above 1,199, and a geometric pool escalates off the 5 x 5 grid above 2,099. Above a cap the tier
 *     says so rather than extrapolating a number nobody would honour.
 *   - Stay scoped to its own container. The mockup renders the page twice, once per preview panel, and
 *     ids duplicated across them is what made every price read as a dash for three builds.
 *
 * One function scope, like every other APS script. */
(() => {
  function money(n) { return '$' + (Math.round(n / 5) * 5).toLocaleString(); }

  function wire(root) {
    var cfgEl = root.querySelector('[data-sc-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var TIERS = cfg.tiers || [], SHAPES = cfg.shapes || {};
    var q = function (s) { return root.querySelector(s); };
    var shape = q('[data-e="shape"]'), len = q('[data-e="len"]'), wid = q('[data-e="wid"]');
    if (!shape || !len || !wid) return;

    function run() {
      var sh = SHAPES[shape.value];
      if (!sh) return;
      var L = Math.max(4, +len.value || 0), W = Math.max(4, +wid.value || 0);
      var add = sh.overlap === 'freeform' ? 3 : (L * W < 1200 ? 2 : 3);
      var cl = L + add, cw = W + add, sq = Math.round(cl * cw);
      var col = sh.rateCol === 'freeform' ? 3 : sh.rateCol === 'geo3x3' ? 2 : 1;
      var escalated = (sh.rateCol === 'geo' && sq > 2099);
      if (escalated) col = 2;

      var sizeEl = q('[data-e="size"]'), sqftEl = q('[data-e="sqft"]'), gridEl = q('[data-e="grid"]');
      if (sizeEl) sizeEl.textContent = cl + ' x ' + cw + ' ft cover';
      if (sqftEl) sqftEl.textContent = sq.toLocaleString() + ' sq ft, from a ' + L + ' x ' + W + ' ft pool';
      if (gridEl) gridEl.textContent = (col === 1 ? '5 x 5 ft grid' : '3 x 3 ft grid');

      var over = 0;
      TIERS.forEach(function (t) {
        var el = q('[data-p="' + t.key + '"]');
        if (!el) return;
        el.classList.remove('na');
        if (sq > t.maxSqft) {
          el.textContent = cfg.notMadeLabel || 'Not made this big';
          el.classList.add('na');
          over += 1;
          return;
        }
        var rate = null;
        for (var i = 0; i < t.brackets.length; i += 1) {
          if (sq <= t.brackets[i][0]) { rate = t.brackets[i][col]; break; }
        }
        if (rate == null) rate = t.brackets[t.brackets.length - 1][col];
        el.textContent = money(rate * sq + sh.adder);
      });

      var bits = [];
      if (sh.adder) bits.push('This shape carries a ' + money(sh.adder) + ' allowance for the corner or step work.');
      if (escalated) bits.push('Past 2,099 sq ft a 5 x 5 grid is not produced, so this prices on the tighter grid.');
      if (col > 1 && !escalated) bits.push('The tighter grid means more straps, more springs and more anchors for the same area.');
      if (over) bits.push('A blank tier is not produced at this size; ask and we will say what is.');
      bits.push(cfg.estimateNote || '<b>An estimate, not a quote.</b> The deck and anything the cover works around are settled once a person has your measurements.');
      var note = q('[data-e="note"]');
      if (note) note.innerHTML = bits.join(' ');

      /* Carry the pool into the short form below, so nobody is asked for it twice. */
      var echo = document.querySelector('[data-sc-echo]');
      if (echo) {
        echo.textContent = cl + ' x ' + cw + ' ft cover for a ' + L + ' x ' + W + ' ft '
          + shape.options[shape.selectedIndex].text.toLowerCase();
      }
      /* And into the hidden field the form posts, so the request carries it too. */
      var field = document.querySelector('[data-sc-pool-field]');
      if (field) {
        field.value = shape.options[shape.selectedIndex].text + ', about ' + L + ' x ' + W + ' ft. '
          + 'Estimator says a ' + cl + ' x ' + cw + ' ft cover, ' + sq.toLocaleString() + ' sq ft, '
          + (col === 1 ? '5 x 5' : '3 x 3') + ' grid.';
      }
    }

    [shape, len, wid].forEach(function (el) {
      el.addEventListener('input', run);
      el.addEventListener('change', run);
    });
    run();
  }

  /* The option pills light up with their own control. Radios clear their siblings within the same
     group, which is scoped to the group element rather than the document so two forms on one page
     cannot clear each other. */
  function pills() {
    document.querySelectorAll('.aps-sc-lp .sc-opt input').forEach(function (b) {
      b.addEventListener('change', function () {
        var group = b.closest('.sc-opts');
        var scope = (b.type === 'radio' && group) ? group.querySelectorAll('input') : [b];
        Array.prototype.forEach.call(scope, function (x) {
          var label = x.closest('.sc-opt');
          if (label) label.classList.toggle('on', x.checked);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sc-calc]').forEach(wire);
    pills();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
